/**
 * SECTION - CART SIDEBAR - LISTENERS
 */

setupEventListenersForCartSidebar();

// Creates the event listeners
function setupEventListenersForCartSidebar() {
  // On clicking on the button to open or close the side cart
  document.querySelectorAll('[data-action="open-cart-sidebar"], [data-action="close-cart-sidebar"]').forEach((element) => {
    element.addEventListener('click', toggleCartSidebarHandler);
  });
}

// When an item is added to the cart and opens the side cart
document.addEventListener('product.added.drawer', productAddedDrawerHandler);

// When an item is added to the cart and displays a message
document.addEventListener('product.added.message', productAddedMessageHandler);

/**
 * SECTION - CART SIDEBAR - GENERAL
 */

// On clicking on the button to open or close the side cart
function toggleCartSidebarHandler() {
  event.preventDefault();
  toggleSidebar('cart');
}

// When an item is added to the cart and opens the side cart
function productAddedDrawerHandler() {
  productAddedDrawer();
}

// When an item is added to the cart and displays a message
function productAddedMessageHandler() {
  productAddedMessage();
}

// Opens and updates the side cart
function productAddedDrawer() {
  var cartSidebar = document.querySelector('.section__page.cart-sidebar');

  toggleSidebar('cart');
  cartSidebar.classList.add('cart--reloading');
  renderCartSidebar();
};

// Updates the number of items in the cart
function productAddedMessage() {
  var cartSidebar = document.querySelector('.section__page.cart-sidebar');

  cartSidebar.classList.add('cart--reloading');
  renderCartSidebar();
};

// Reloads the side cart
function renderCartSidebar() {    
  fetch(window.theme.localeRootUrl)
    .then((response) => response.text())
    .then((response) => { 
      var selector = '#cart-sidebar__container',
          cartSidebarContainer = document.querySelector(selector);
      
      cartSidebarContainer.innerHTML = getSectionInnerHTML(response, selector);
      setupEventListenersAfterFetchingCartSidebar();
      checkCartContent('');
      setSidebarContentsHeight('cart');
      document.querySelector('.cart--reloading')?.classList.remove('cart--reloading');
      updateCartItemsCountAndButtonsPrice();
    });
}

// Creates the event listeners needed after fetch
function setupEventListenersAfterFetchingCartSidebar() {
  setupEventListenersForCartSidebar();
  setupEventListenersForCartItems();
  setupEventListenersForModals();
  setupEventListenersForCartSummary();
  setupEventListenersForProductsItems();
}

// Updates the number of items in the cart and the buttons containing the cart total
function updateCartItemsCountAndButtonsPrice() {
  var cartItemsCount = document.querySelectorAll('.cart-icon-wrapper__count'),
      cartIconsFull = document.querySelectorAll('.cart-icon-wrapper--has-items'),
      cartIconsEmpty = document.querySelectorAll('.cart-icon-wrapper--empty'),
      buttonsPrice = document.querySelectorAll('.button-price-to-update'); // DEPRECATED

  fetch(`${routes.cartUrl}`, { ...fetchConfig('GET') })
    .then((response) => response.text())
    .then((response) => {   
      const results = JSON.parse(response);
      var itemsCount = results.item_count,
          newTotalPrice = results.total_price,
          newTotalPriceFormatted = Shopify.formatMoney(newTotalPrice, window.theme.moneyFormat); // or: convertToPriceFormat(newTotalPrice);
      
      // Updates the total price in each button
      buttonsPrice.forEach((element) => {      
        element.setAttribute('data-total-price', newTotalPrice);
        element.querySelector('.button-price-value').textContent = newTotalPriceFormatted;        
        if (itemsCount <= 0) element.classList.add('hidden');
      });      
  
      // Update the cart icon in the header
      if (itemsCount > 0) {
        cartItemsCount.forEach((element) => { element.textContent = itemsCount; }); 
        cartIconsFull.forEach((element) => { element.style.display = 'block'; }); 
        cartIconsEmpty.forEach((element) => { element.style.display = 'none'; }); 
      } else {
        cartIconsFull.forEach((element) => { element.style.display = 'none'; }); 
        cartIconsEmpty.forEach((element) => { element.style.display = 'block'; });
      }
    });
}